export default "__VITE_ASSET__B2ahAGg6__"